import { useMutation } from '@tanstack/react-query'
import { FormikHelpers } from 'formik'

import { useInvalidateReferralLinksQueries } from '@/components/misc/ReferralLinksTable/hooks/useInvalidateReferralLinksQueries'
import { EditCalendarCodeFormValues } from '@/components/misc/ReferralLinksTable/lib/constants'
import { useHandleApiError } from '@/hooks/useHandleApiError'
import useNotyf from '@/hooks/useNotyf'
import referralLinkService from '@/lib/services/referralLinkService'
import { UpdateReferralLinkCodeRequest } from '@/types/requests/referral-links'

interface MutationVariables {
  referralLinkId: number
  request: UpdateReferralLinkCodeRequest
  formikHelpers: FormikHelpers<EditCalendarCodeFormValues>
}

export function useUpdateCalendarLinkCodeMutation() {
  const notyf = useNotyf()
  const invalidateReferralLinksQueries = useInvalidateReferralLinksQueries()
  const handleApiError = useHandleApiError()

  return useMutation({
    mutationFn: ({ referralLinkId, request }: MutationVariables) =>
      referralLinkService.updateReferralLinkCode(referralLinkId, request),
    onSuccess: async (_response) => {
      await invalidateReferralLinksQueries()

      notyf.success('Calendar link code updated successfully')
    },
    onError: (error, { formikHelpers }) => {
      handleApiError({ error, formikHelpers })
    },
  })
}
